import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import cuid from "cuid";

function withTooltip(Component) {
  return class TooltipWrapper extends React.Component {
    static propTypes = {
      children: PropTypes.any,
    };
    id = cuid();
    render() {
      return (
        <React.Fragment>
          <Component {...this.props} tooltipId={this.id} />
          <ReactTooltip effect="solid" id={this.id} />
        </React.Fragment>
      );
    }
  };
}

export default withTooltip;



// WEBPACK FOOTER //
// ./src/components/HOC/withTooltip.jsx